// @flow

export default class PaymentOption {
  type: string
  issuerName: ?string
}

const buildPaymentOption = function (type: string, issuerName: ?string): PaymentOption {
  const paymentOption = new PaymentOption()
  paymentOption.type = type
  paymentOption.issuerName = issuerName
  return paymentOption
}

export {
  buildPaymentOption
}



// WEBPACK FOOTER //
// ./src/types/payment-option.js